import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { apiAction, generalSet } from '../../store/generalSlice';

const CreateIncomingWebhook = () => {
  const dispatch = useDispatch();
  const [webhookData, setWebhookData] = useState({ whType: 'CUSTOM', status: 'ACTIVE' });
  const { webhookCreated, createWebhookLoading } = useSelector((state) => state.general);

  if (webhookCreated?._id) {
    dispatch(generalSet({ reduxField: 'webhookCreated', value: {} }));
    window.location.href = '/IncomingWebhooks';
  }
  console.log({ webhookCreated, webhookData });

  return (
    <>
      <div>
        <Link to='/IncomingWebhooks' className='btn btn-outline-dark'>
          Webhooks
        </Link>
      </div>
      <div className='container mt-4' data-aos='fade-up' data-aos-delay='200'>
        <div className='row d-flex justify-content-center border-bottom'>
          <h1>Create Webhook</h1>
        </div>
        <div className='row d-flex justify-content-center mt-4'>
          <div className='col-md-6 p-3 border'>
            Name
            <input
              type='text'
              className='form-control'
              placeholder='Webhook name...'
              style={{ textAlign: 'center' }}
              onChange={(e) => setWebhookData({ ...webhookData, name: e.target.value })}
            />
          </div>
          <div className='col-md-6 p-3 border'>
            Type
            <select
              type='text'
              className='form-control select'
              style={{ textAlign: 'center' }}
              onChange={(e) => setWebhookData({ ...webhookData, whType: e.target.value })}
            >
              <option value='CUSTOM'>Custom</option>
              <option value='GENERATE_IMAGE_MAKE'>Generate Image (Make)</option>
            </select>
          </div>
          <div className='col-md-6 p-3 border'>
            URL
            <input
              type='text'
              className='form-control'
              placeholder='https://example.com/webhook'
              style={{ textAlign: 'center' }}
              onChange={(e) => setWebhookData({ ...webhookData, url: e.target.value })}
            />
          </div>
          <div className='col-md-6 p-3 border'>
            Status
            <select
              type='text'
              className='form-control select'
              style={{ textAlign: 'center' }}
              onChange={(e) => setWebhookData({ ...webhookData, status: e.target.value })}
            >
              <option value='ACTIVE'>ACTIVE</option>
              <option value='PAUSED'>PAUSED</option>
            </select>
          </div>
        </div>
        <div className='row d-flex justify-content-center mt-4'></div>
        {webhookCreated?.msg ? (
          <>
            <div className='row d-flex justify-content-center mt-4' data-aos='fade-up' data-aos-delay='200'>
              <h5 className='text-danger'>{webhookCreated.msg}</h5>
            </div>
          </>
        ) : null}
        {webhookData.name && webhookData.url ? (
          <>
            <div className='row d-flex justify-content-center mt-4' data-aos='fade-up' data-aos-delay='200'>
              <button
                className='btn btn-outline-primary'
                disabled={createWebhookLoading}
                onClick={() => {
                  dispatch(generalSet({ reduxField: 'createWebhookLoading', value: true }));
                  dispatch(
                    apiAction({
                      route: 'incomingWebhooks/createIncomingWebhook',
                      reduxField: 'webhookCreated',
                      webhookData,
                      setLoading: 'createWebhookLoading',
                    })
                  );
                }}
              >
                Create Webhook
              </button>
            </div>
          </>
        ) : null}
      </div>
    </>
  );
};

export default CreateIncomingWebhook;
